"use client";
import * as React from "react";
const SvgSentimentDissatisfiedOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M10.8 7.2a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4m-5.6 0a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4" }), /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8 9.6a4.4 4.4 0 0 0-4.1 2.8h1.34A3.2 3.2 0 0 1 8 10.8c1.18 0 2.2.65 2.76 1.6h1.34A4.4 4.4 0 0 0 8 9.6M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 14.4A6.4 6.4 0 0 1 1.6 8 6.4 6.4 0 1 1 8 14.4" }));
export {
  SvgSentimentDissatisfiedOutlined as default
};
